export const TITLE = 'Title'
export const SHORT_DESCRIPTION = 'Introduction'
export const VIEW_PERMISSIONS = 'View Permissions'
export const USER_TYPE_PERMISSIONS = 'User Type Permissions'
export const CATEGORY = 'Category'
export const SUB_CATEGORIES = 'Sub Categories'
export const UPDATE_FREQUENCY = 'Update Frequency'
export const AGENCY = 'Agency'
export const PUBLISHED = 'Published'
export const NAME = 'Name'
export const INTRODUCTION = 'Introduction'
export const QLIK_URL = 'Qlik URL'
export const PASSWORD = 'Password'
export const FIRST_NAME = 'First Name'
export const LAST_NAME = 'Second Name'
export const EMAIL = 'Email'
export const USER_TYPE = 'User Type'
export const ATTACHMENT = 'Select document to upload'
export const CATEGORY_SELECT = 'Categories'
export const ORGANISATION_SELECT = 'View Permissions'
export const PUBLISHED_SELECT = 'Publish?'
export const QLIK_URL_INPUT = 'Qlik URL'
export const QLIK_FILTER_URL_INPUT = 'Qlik Filter URL'
export const SHORT_DESCRIPTION_INPUT = 'Introduction'
export const TITLE_INPUT = 'Title'
export const UPDATE_FREQUENCY_SELECT = 'Update Frequency'
export const USER_TYPE_SELECT = 'User Type'
export const ASSOCIATED_DATASET = 'Associated Dataset'
export const SITE_SELECT = 'Site'
export const TAGS = 'Tags'
export const TEMPLATES = 'Templates'
export const SEND_EMAILS = 'Notify Associated Users'
export const PRIMARY_COLOR = 'Primary Color'
export const GROUP_UUID = 'Group UUID'
export const GROUP_NAME = 'Group Name'
export const AUTHOR = 'Author'
export const LANDING_PAGE = 'Set as Landing page'
export const SHOW_TOGGLE = 'Show Site In Sidebar'
